var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconPrinted = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18.721,
  height: 18.537,
  viewBox: "0 0 18.721 18.537",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group_276",
  "data-name": "Group 276",
  transform: "translate(-174.072 -580.727)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_181",
  "data-name": "Path 181",
  d: "M200.335,624.346v-.036a.1.1,0,0,0-.1-.1h-6.181a.1.1,0,0,0-.1.1v.871a.1.1,0,0,0,.1.1h5.715",
  transform: "translate(-14.356 -31.581)",
  fill: "none",
  stroke: "#119c4a",
  strokeMiterlimit: 10,
  strokeWidth: 0.45
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_182",
  "data-name": "Path 182",
  d: "M198.525,620.563v-.185a.1.1,0,0,0-.1-.1h-8.305a.1.1,0,0,0-.1.1V625.5a.1.1,0,0,0,.1.1h6.831",
  transform: "translate(-11.485 -28.711)",
  fill: "none",
  stroke: "#119c4a",
  strokeMiterlimit: 10,
  strokeWidth: 0.45
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_183",
  "data-name": "Path 183",
  d: "M199.491,632.082h-5.433a.1.1,0,0,0-.1.1v.872a.1.1,0,0,0,.1.095h5.45",
  transform: "translate(-14.356 -37.324)",
  fill: "none",
  stroke: "#119c4a",
  strokeMiterlimit: 10,
  strokeWidth: 0.45
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_184",
  "data-name": "Path 184",
  d: "M198.525,581.265a.313.313,0,0,0-.313-.313h-7.869a.313.313,0,0,0-.313.313v4.683a.313.313,0,0,0,.313.313h7.869a.313.313,0,0,0,.313-.313v-4.683Z",
  transform: "translate(-11.485)",
  fill: "none",
  stroke: "#119c4a",
  strokeMiterlimit: 10,
  strokeWidth: 0.45
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_185",
  "data-name": "Path 185",
  d: "M191.126,600.528a2.663,2.663,0,0,0,.163-.91v-4.743a2.13,2.13,0,0,0-2.124-2.124H188.1v2.97a.216.216,0,0,1-.216.216H177.7a.215.215,0,0,1-.216-.216v-2.97h-1.063a2.13,2.13,0,0,0-2.124,2.124v5.31a2.13,2.13,0,0,0,2.124,2.124h1.063v-2.97a.216.216,0,0,1,.216-.216h10.188a.216.216,0,0,1,.216.216v.694",
  transform: "translate(0 -8.613)",
  fill: "none",
  stroke: "#119c4a",
  strokeMiterlimit: 10,
  strokeWidth: 0.45
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_186",
  "data-name": "Path 186",
  d: "M215.811,625.805a3.5,3.5,0,0,0,.287.956,3.671,3.671,0,1,0-.287-.956Z",
  transform: "translate(-30.273 -29.774)",
  fill: "none",
  stroke: "#119c4a",
  strokeMiterlimit: 10,
  strokeWidth: 0.45
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_187",
  "data-name": "Path 187",
  d: "M221.281,630.865a.392.392,0,0,1,.342.134l.561.655,2.782-2.472a.393.393,0,1,1,.522.588l-3.081,2.739a.4.4,0,0,1-.262.1h-.027a.4.4,0,0,1-.272-.137l-.566-.661-.255-.3a.393.393,0,0,1,.255-.647Z",
  transform: "translate(-34.042 -35.134)",
  fill: "none",
  stroke: "#119c4a",
  strokeMiterlimit: 10,
  strokeWidth: 0.45
}))));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconPrinted, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_printed.4080f1f0.svg";
export { ForwardRef as ReactComponent };